import { DNA } from "react-loader-spinner";

const LoaderSpinner = ({
  height = "80",
  width = "80",
  wrapperClassName = "d-flex justify-content-center align-items-center vh-100",
}) => {
  return (
    <div className={wrapperClassName}>
      <DNA
        visible={true}
        height={height}
        width={width}
        ariaLabel="dna-loading"
        wrapperStyle={{}}
        wrapperClass="dna-wrapper"
        dnaColorOne="#0297d5"
        dnaColorTwo="#c6d630"
      />
    </div>
  );
};

export default LoaderSpinner;
